"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NewWindowPopup;
var _react = _interopRequireWildcard(require("react"));
var _reactNewWindow = _interopRequireDefault(require("react-new-window"));
var _excluded = ["onOpen", "setWindowPopup"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var subscriber = new Map();
var styles = new Set();
var addStyle = function addStyle(style) {
  styles.add(style);
  Array.from(subscriber.values()).forEach(function (head) {
    head.appendChild(style.cloneNode(true));
  });
};
var copyStyle = function copyStyle(target) {
  styles.forEach(function (style) {
    return target.appendChild(style.cloneNode(true));
  });
};
var mutationObserver = new MutationObserver(function (mutationList) {
  mutationList.forEach(function (_ref) {
    var addedNodes = _ref.addedNodes,
      removedNodes = _ref.removedNodes;
    _toConsumableArray(addedNodes).forEach(function (node) {
      if (!(node instanceof HTMLStyleElement)) return;
      addStyle(node);
    });
    _toConsumableArray(removedNodes).forEach(function (node) {
      if (!(node instanceof HTMLStyleElement)) return;
      styles.has(node) && styles["delete"](node);
    });
  });
});
mutationObserver.observe(document.head, {
  childList: true
});
function NewWindowPopup(_ref2) {
  var _onOpen = _ref2.onOpen,
    setWindowPopup = _ref2.setWindowPopup,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var id = (0, _react.useId)();
  (0, _react.useEffect)(function () {
    return function () {
      subscriber["delete"](id);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_reactNewWindow["default"], _extends({
    onOpen: function onOpen(window) {
      if (!subscriber.has(id)) subscriber.set(id, window.document.head);
      _onOpen === null || _onOpen === void 0 || _onOpen(window);
      subscriber.set(id, window.document.head);
      copyStyle(window.document.head);
      if (window) {
        setWindowPopup(window);
      }
    }
  }, rest));
}